import { Button as Button$1 } from './Button.js';
import { ButtonGroup } from './ButtonGroup/ButtonGroup.js';
import { ToggleButton } from './ToggleButton/ToggleButton.js';

var Button = Button$1;
Button.Group = ButtonGroup;
Button.Toggle = ToggleButton;
Button.Group.displayName = 'Button.Group';
Button.Toggle.displayName = 'Button.Toggle';

export { Button };
